import CrudTable from '../../components/CrudTable';

// KH#1 (câu chuyện), KH#4 (địa chỉ + maps_query), bank QR (key: payment).
export default function ContentAdmin() {
  return (
    <CrudTable
      title="📝 Nội dung site (câu chuyện, cửa hàng, bank QR, hero)"
      table="site_content"
      idCol="key"
      orderBy="key"
      ascending
      columns={[
        { key: 'key', label: 'Key', type: 'text', required: true },
        { key: 'title', label: 'Tiêu đề (VI)', type: 'text' },
        { key: 'title_en', label: 'Tiêu đề (EN)', type: 'text', inTable: false },
        { key: 'body', label: 'Nội dung (VI)', type: 'textarea', inTable: false },
        { key: 'body_en', label: 'Nội dung (EN)', type: 'textarea', inTable: false },
        { key: 'image_url', label: 'Ảnh (URL)', type: 'text', inTable: false },
        { key: 'extra', label: 'Cấu hình JSON', type: 'json' },
      ]}
      beforeSave={(v) => {
        if (typeof v.extra === 'string') {
          const s = v.extra.trim();
          v.extra = s ? JSON.parse(s) : null;
        }
        return v;
      }}
      emptyText="Chưa có nội dung."
    />
  );
}
